import * as actionTypes from 'modules/audits/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const load = () => true;

const reset = () => initialState;

export default createReducer(initialState, {
  [actionTypes.SHARE_AUDIT]: load,
  [actionTypes.SHARE_AUDIT_SUCCESS]: reset,
  [actionTypes.SHARE_AUDIT_FAILURE]: reset,
});
